"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Callout, Dialog, Flex, Select, Text, VisuallyHidden, } from "@radix-ui/themes";
import { useState } from "react";
import { useUpdateUserRole } from "./api/user";
import { DialogContent, PrimaryButton, SecondaryButton, SelectContent, SelectItem, SelectTrigger, Skeleton, } from "./elements";
import { getBestName } from "./utils";
import { useRoles } from "../api";
export function EditUserRoleDialog({ children, user, ...props }) {
    const displayName = getBestName(user) || user.email;
    const rolesQuery = useRoles({
        query: {
            initialData: [],
        },
    });
    const { data: roles } = rolesQuery;
    const updateUser = useUpdateUserRole();
    const [selectedRole, setSelectedRole] = useState(user.roles?.at(0)?.slug || "Unknown");
    const onSubmitForm = ({ id, roles }) => {
        updateUser.mutate({ userId: id, data: { roles } }, {
            onSuccess: () => {
                props.onOpenChange(false);
            },
        });
    };
    const rootId = React.useId();
    const formId = `edit-user-form-${rootId}`;
    const selectId = `role-select-${rootId}`;
    const selectLabelId = `${selectId}-label`;
    const infoId = `${selectId}-info`;
    const errorId = `${selectId}-error`;
    const showErrorMessage = !!rolesQuery.error;
    const showSingleRoleInfo = rolesQuery.isSuccess && roles.length === 1;
    return (_jsxs(Dialog.Root, { ...props, children: [children && _jsx(Dialog.Trigger, { children: children }), _jsxs(DialogContent, { maxWidth: "480px", children: [_jsx(Dialog.Title, { children: "Edit role" }), _jsxs(Dialog.Description, { children: ["Select the role to assign to ", _jsx(Text, { weight: "bold", children: displayName })] }), _jsx(Flex, { mt: "2", direction: "column", gap: "1", asChild: true, children: _jsxs("form", { id: formId, onSubmit: async (event) => {
                                event.preventDefault();
                                onSubmitForm({ id: user.id, roles: [selectedRole] });
                            }, children: [_jsxs(Select.Root, { name: "roles", value: selectedRole ?? "Unknown", onValueChange: setSelectedRole, disabled: rolesQuery.isLoading || showSingleRoleInfo, children: [_jsx(Skeleton, { loading: rolesQuery.isLoading, children: _jsx(SelectTrigger, { id: selectId, placeholder: "Assign a role", "aria-labelledby": selectLabelId, "aria-invalid": showErrorMessage || undefined, "aria-describedby": [showErrorMessage && errorId, showSingleRoleInfo && infoId]
                                                    .filter(Boolean)
                                                    .join(" ") || undefined }) }), _jsx(SelectContent, { children: roles.map((role) => (_jsx(SelectItem, { value: role.slug, children: role.name }, role.slug))) })] }), showErrorMessage ? (_jsx(Text, { color: "red", size: "2", id: errorId, children: getRoleSelectErrorMessage(rolesQuery.error) })) : null, showSingleRoleInfo ? (_jsx(Text, { color: "gray", size: "2", id: infoId, mt: "1", children: "You cannot update the role for this user as there is only one role available." })) : null] }) }), updateUser.error ? (_jsx(Callout.Root, { color: "red", mt: "4", mb: "-2", children: _jsx(Callout.Text, { children: getMutationErrorMessage(updateUser.error) }) })) : null, _jsxs(Flex, { mt: "5", gap: "3", justify: "end", children: [_jsx(Dialog.Close, { children: _jsx(SecondaryButton, { disabled: updateUser.isPending, children: "Cancel" }) }), _jsx(PrimaryButton, { form: formId, loading: updateUser.isPending, disabled: rolesQuery.isLoading || showSingleRoleInfo || undefined, children: "Save" })] }), _jsx(VisuallyHidden, { asChild: true, children: _jsx("section", { "aria-live": "polite", children: getMutationErrorMessage(updateUser.error) }) })] })] }));
}
function getRoleSelectErrorMessage(error) {
    if (!error) {
        return null;
    }
    // TODO Handle server errors
    return "There was an error fetching roles. Please try again.";
}
function getMutationErrorMessage(error) {
    if (!error) {
        return null;
    }
    // TODO Handle server errors
    return "There was an error updating the user role. Please try again.";
}
//# sourceMappingURL=edit-user-role-dialog.js.map